module.exports = __webpack_public_path__ + "img/img-8.1d1c9cd8.png";